export interface GRecaptcha {
  ready: () => void
  execute: (recaptcha_site_key: string) => Promise<string>
}

interface WindowWithRecaptcha {
  grecaptcha: GRecaptcha
}

declare const window: WindowWithRecaptcha

export function isLoaded(): boolean {
  return 'grecaptcha' in window
}

export default async function execute(
  recaptchaSiteKey: string
): Promise<string> {
  return window.grecaptcha.execute(recaptchaSiteKey)
}
